import React from "react";

export default function ListMenu({ userType }) {
  // ⭐ Helper for conditional CSS classes
  const cls = (...names) => {
    return userType === 1 ? [...names, "small"].join(" ") : names.join(" ");
  };

  return (
    <div className="menuContainer primary white">
      <div className={cls("menuUsername")}>Username</div>
      <div className={cls("menuUsername")}>Booked</div>
      <div className={cls("menuUsername")}>Net-Booked</div>
      <div className={cls("menuName")}>Sharing</div>
      <div className={cls("menuName")}>Tpassword</div>
      <div className={cls("menuName")}>Trade</div>
      <div className={cls("menuName")}>Close Only</div>
      <div className={cls("menuName")}>Status</div>
      <div className={cls("menuName")}>Ip Address</div>
      <div className={cls("menuName")}>Created Date</div>
      <div className={cls("menuName")}>Last Login</div>
      <div className={cls("menuName")}></div>
    </div>
  );
}
